<!--
 * @Author: zyy
 * @Date: 2022-03-28 10:51:12
 * @LastEditors: zyy
 * @LastEditTime: 2022-07-26 15:35:39
 * @Description: default
-->
<template>
  <div class="base">
    <a-layout>
      <a-layout-sider theme="light">
        <a-row class="logo"
               type="flex"
               align="middle"
               justify="center">
          <a-col>
            <!-- <dy-image :src="require('../../assets/images/logo.png')"></dy-image> -->
          </a-col>
          <a-col>智慧社区管理系统</a-col>
        </a-row>
        <div class="side-bar-wrap">
          <side-bar></side-bar>
        </div>
      </a-layout-sider>
      <a-layout>
        <a-layout-header>
          <top-bar></top-bar>
        </a-layout-header>
        <a-layout-content>
          <breadcrumb></breadcrumb>
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
          </keep-alive>
          <router-view v-if="!$route.meta.keepAlive"></router-view>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </div>
</template>

<script>
import TopBar from '@/components/TopBar.vue';
import SideBar from '@/components/SideBar.vue';
import Breadcrumb from '@/components/Breadcrumb.vue';

export default {
  name: 'Base',
  components: {
    TopBar,//头部栏
    SideBar,//侧边栏
    Breadcrumb
  },
}
</script>

<style lang="less" scoped>
@import "../../assets/styles/tools.less";
.base {
  height: 100%;
  & > * {
    height: 100%;
  }
  .ant-layout-sider {
    .logo {
      width: 100%;
      height: @layout-header-height;
      background-color: @white;
      position: relative;
      .ant-col {
        &:nth-of-type(1) {
          margin-right: 6px;
          .dy-image {
            width: 30px;
            height: 30px;
          }
        }
        &:nth-of-type(2) {
          font-size: 18px;
          font-weight: bold;
        }
      }
    }
    .side-bar-wrap {
      height: calc(100% - @layout-header-height);
      box-shadow: @box-shadow-base;
      overflow: auto;
    }
  }
  .ant-layout-header {
    background-color: @white;
    box-shadow: @box-shadow-base;
    padding: 0;
    position: relative;
    z-index: 1;
  }
  .ant-layout-content {
    overflow: auto;
  }
}
</style>